import React from 'react';
import { CircleCheckIcon, CircleXIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/content';
export function Difference() {
  return <section className="w-full bg-chalk px-5 py-20 sm:py-28" data-id="element-44" data-mp="a5t49fsozck">
      <div className="mx-auto max-w-5xl" data-id="element-45" data-mp="9vz8armq81l">
        <div className="mx-auto max-w-3xl text-center" data-id="element-46" data-mp="58z5tzn9cmbo">
          <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-brand" data-id="element-47" data-mp="57ebob4uv5ec">
            The Football Ready Difference
          </span>
          <h2 className="mt-4 font-display text-[2.25rem] font-extrabold uppercase leading-[0.98] text-ink sm:text-5xl" data-id="element-48" data-mp="3rgyq113k2cba">
            From an Overwhelmed Coach to a{' '}
            <span className="text-brand" data-id="element-49" data-mp="3dj0qv2xt2mgd">Confident Leader.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-ink/60 sm:text-base" data-id="element-50" data-mp="3ig0u7639tb3s">
            Give your sessions a professional rhythm, your players more tactical
            intelligence, and yourself the time to enjoy coaching again.
          </p>
        </div>

        <dl className="mx-auto mt-11 grid max-w-3xl grid-cols-1 overflow-hidden rounded-2xl border border-ink/10 bg-white sm:grid-cols-3" data-id="element-51" data-mp="1j9ui677ubxku">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`px-6 py-7 text-center ${index > 0 ? 'border-t border-ink/10 sm:border-l sm:border-t-0' : ''}`} data-id="element-52" data-mp="1szxae57517i4" data-mpi={index}>
              <dt className="sr-only" data-id="element-53" data-mp="wapmwrmykobk">{stat.label}</dt>
              <dd data-id="element-54" data-mp="wc10fj67hafv">
                <span className="block font-display text-4xl font-extrabold text-brand" data-id="element-55" data-mp="wciuc95ebckm">
                  {stat.value}
                </span>
                <span className="mt-1.5 block text-[10px] font-bold uppercase tracking-[0.14em] text-ink/50" data-id="element-56" data-mp="15auvh53w1srb">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <div className="mt-14 overflow-hidden rounded-3xl bg-white shadow-soft" data-id="element-57" data-mp="2gphwgwyl8kvm">
          <div className="grid md:grid-cols-2" data-id="element-58" data-mp="2orsb6w580vpd">
            <div className="relative bg-sand p-8 sm:p-10" data-id="element-59" data-mp="2oqz5zzlwue9c">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white text-ink/40" data-id="element-60" data-mp="2srsxf2ykab6z">
                <CircleXIcon className="h-5 w-5" aria-hidden="true" data-id="element-61" data-mp="2xpufplo5y6he" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-ink/45" data-id="element-62" data-mp="32q8q3ad8lsil">
                The cost of improvising
              </span>
              <h3 className="mt-3 font-display text-3xl font-extrabold uppercase tracking-wide text-ink" data-id="element-63" data-mp="2a1t9ijegj255">
                Before
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-ink/55" data-id="element-64" data-mp="2f04mv43ynus4">
                What planning from scratch quietly takes from your week.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-65" data-mp="1mbqkkc5uacar">
                {beforeItems.map(item => <li key={item} className="flex items-center gap-3 rounded-xl bg-white/70 px-4 py-3 text-sm text-ink/65" data-id="element-66" data-mp="1ratizdrbdk9r">
                    <CircleXIcon className="h-4 w-4 shrink-0 text-ink/35" aria-hidden="true" data-id="element-67" data-mp="1espo2atghiww" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="relative bg-white p-8 sm:p-10" data-id="element-68" data-mp="14xfodtqj5nma">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-brand text-white" data-id="element-69" data-mp="10u9mszed4km5">
                <CircleCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-70" data-mp="w0wykqdliftx" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-brand" data-id="element-71" data-mp="r1ke2ca75kui">
                The Football Ready system
              </span>
              <h3 className="mt-3 font-display text-3xl font-extrabold uppercase tracking-wide text-ink" data-id="element-72" data-mp="h4foe2h5778y">
                With Football Ready
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-ink/55" data-id="element-73" data-mp="11ujii8educ83">
                Walk onto every pitch with a clear, structured plan.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-74" data-mp="16sut4lci4qrd">
                {afterItems.map(item => <li key={item} className="flex items-center gap-3 rounded-xl bg-brand-light px-4 py-3 text-sm font-medium text-ink" data-id="element-75" data-mp="t1pzq0zq8uph">
                    <CircleCheckIcon className="h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-76" data-mp="j2h1gvxtwtxb" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
          <p className="border-t border-ink/5 bg-chalk px-6 py-4 text-center text-xs text-ink/50" data-id="element-77" data-mp="e60a7svc1zg0">
            A complete system to plan less and coach with more purpose.
          </p>
        </div>
      </div>
    </section>;
}